import { render } from "./ui-carousel.vue?vue&type=template&id=1521c510"
import script from "./ui-carousel.vue?vue&type=script&lang=js"
export * from "./ui-carousel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__